import { isNil } from "es-toolkit/compat";

export const mapDeliveryScheduledAt = (
    deliveryScheduledAt: Optional<string>,
): string | undefined =>
    isNil(deliveryScheduledAt) ? undefined : deliveryScheduledAt;
